import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IBarChart } from './types';

const RenderGraphBar: React.FC<IBarChart> = ({
  data,
  dataKeyBar,
  dataKeyXAxis,
  color,
  isPercentage,
  name,
  ...rest
}) => {
  const formatPercentage = (value: any) => {
    if (isPercentage) {
      return `${value}%`;
    }
    return value;
  };

  const formatter = (value: any) => {
    if (isPercentage) {
      return formatPercentage(Number(value).toFixed(2));
    }
    return value;
  };

  return (
    <ResponsiveContainer height={300} width="100%">
      <BarChart height={300} data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={dataKeyXAxis} />
        <YAxis width={80} tickFormatter={formatter} />
        <Tooltip
          contentStyle={{
            borderRadius: 8,
            backgroundColor: '#b7ffbd',
            border: '1px solid #005f47',
            display: 'flex',
            gap: 5,
            flexDirection: 'column',
          }}
          labelStyle={{
            fontWeight: 'bold',
            fontSize: 18,
            borderBottom: '1px solid #005f47',
            color: '#005f47',
          }}
          formatter={formatter}
        />
        <Bar
          fill={color}
          name={name}
          {...rest}
          strokeWidth={3}
          dataKey={dataKeyBar}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RenderGraphBar;
